import React from 'react'
import { SVGIconProps } from '../types'
const SvgBatteryCharging50 = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M10.222 7.556H8.444V4L6.222 8.444l-.444.89h1.778v3.555l2.222-4.445zm1.334 5.777c0 .49-.4.89-.89.89H5.334a.89.89 0 0 1-.889-.89V3.556c0-.49.4-.89.89-.89h1.333V1.334h2.666v1.334h1.334c.489 0 .889.4.889.889Z"
      />
    </g>
  </svg>
)
export default SvgBatteryCharging50
